// P8-05 (WCAG 2.2 2.4.11 Focus Not Obscured): keeps keyboard focus clear of the sticky header and the sticky bars.
// The browser scrolls a focused element into view but ignores scroll-padding for focus in Chromium, and the
// bars slide in after that scroll. So after each focus move (once any smooth scroll has ended) and whenever
// a bar appears (window.vitaKeepFocusClear()), the page is nudged so the focused element sits clear of them.
// Loaded once from sections/vita-header.liquid.

const OBSTRUCTIONS = '#header-component, .vita-landing-sticky[data-visible], .vita-sticky-atc[data-visible]';
const GAP = 12;

// a nudge up can bring the hidden header back, which moves the desktop sticky bar down under it: look again
let tries = 0;
function check() {
  if (nudge() && ++tries < 3) schedule(450, true);
  else tries = 0;
}

function nudge() {
  const el = document.activeElement;
  // focus in an open dialog (cart drawer, search, nav drawer) sits above the page: nothing to move
  if (!el || el === document.body || !el.matches(':focus-visible') || el.closest('dialog[open]')) return false;
  const r = el.getBoundingClientRect();
  if (!r.width && !r.height) return false;
  for (const bar of document.querySelectorAll(OBSTRUCTIONS)) {
    if (bar.contains(el)) continue;
    const pos = getComputedStyle(bar).position;
    if (pos !== 'fixed' && pos !== 'sticky') continue;
    const b = bar.getBoundingClientRect();
    if (b.bottom <= 0 || b.top >= window.innerHeight || b.height === 0) continue;
    if (r.bottom <= b.top || r.top >= b.bottom) continue;
    // a bar in the top half pushes the element down, one in the bottom half pushes it up
    const top = b.top < window.innerHeight / 2 ? r.top - b.bottom - GAP : r.bottom - b.top + GAP;
    scroller().scrollBy({ top, behavior: 'instant' });
    return true;
  }
  return false;
}

// From 990px Horizon scrolls .page-wrapper (base.css), not the window
function scroller() {
  const wrapper = document.querySelector('.page-wrapper');
  return wrapper && wrapper.scrollHeight > wrapper.clientHeight && getComputedStyle(wrapper).overflowY !== 'visible' ? wrapper : window;
}

let pending = 0;
let waiting = null;
function schedule(delay = 0, retry = false) {
  clearTimeout(pending);
  if (waiting) document.removeEventListener('scrollend', waiting, true);
  if (!retry) tries = 0;
  // wait for a smooth scroll to finish (scrollend, captured so the .page-wrapper one counts too), with a timer
  // for browsers without it (Safari before 26.2) or when nothing scrolls. browser-support: guarded scrollend-event
  const run = () => {
    clearTimeout(pending);
    document.removeEventListener('scrollend', run, true);
    waiting = null;
    requestAnimationFrame(check);
  };
  waiting = run;
  document.addEventListener('scrollend', run, { once: true, capture: true });
  pending = setTimeout(run, delay || 450);
}

if (!window.vitaKeepFocusClear) {
  document.addEventListener('focusin', () => schedule());
  // the bars call this when they appear; their slide in takes about 400ms
  window.vitaKeepFocusClear = () => schedule(450);
}
